<div
  class="ui-loader"
  [class.ui-loader--overlay]="overlay()"
  role="status"
  aria-live="polite"
>
  <span
    class="ui-loader__spinner ui-loader__spinner--{{ size() }}"
    aria-hidden="true"
  ></span>
  @if (label()) {
    <span class="ui-loader__label">{{ label() }}</span>
  }
</div>
